import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const BUYERS = [{
  name: 'María González',
  city: 'Buenos Aires'
}, {
  name: 'Carlos Fernández',
  city: 'Córdoba'
}, {
  name: 'Laura Martínez',
  city: 'Rosario'
}, {
  name: 'Roberto Sánchez',
  city: 'Mendoza'
}, {
  name: 'Ana Rodríguez',
  city: 'La Plata'
}, {
  name: 'Gabriela López',
  city: 'Tucumán'
}, {
  name: 'Diego Ramírez',
  city: 'Mar del Plata'
}, {
  name: 'Patricia Herrera',
  city: 'Santa Fe'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  useEffect(() => {
    const showPopup = () => {
      // Pick a random buyer
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 30000);
    // Then show randomly every 30-40 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 10000) + 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-356">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start gap-3" data-id="element-357">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-358">
            <ShoppingCartIcon className="w-5 h-5 text-green-600" data-id="element-359" />
          </div>
          <div data-id="element-360">
            <p className="text-sm text-gray-800 leading-tight" data-id="element-361">
              <span className="font-bold" data-id="element-362">{currentBuyer.name}</span> de{' '}
              <span className="font-semibold" data-id="element-363">{currentBuyer.city}</span> acaba
              de adquirir el{' '}
              <span className="font-bold text-purple-600" data-id="element-364">
                MEGA PACK RESET DE DOPAMINA™
              </span>
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-365">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}